<div class="container">
  <div class="modal-header" *ngIf="!isLoading">
    <div class="device-header">
      <span>
        <i class="mdi mdi-file-document-edit-outline file-icon"></i>
        <span class="header">Configure JMEP</span>
      </span>
      <i class="mdi mdi-close close-icon" mat-dialog-close></i>
    </div>
  </div>
  <div class="form-container">
    <form novalidate #jmepForm="ngForm">
      <div *ngIf="!isLoading">
        <div class="setup">
          <div class="name-row">
            <div class="input-fields">
              <div class="label"><b>JMEP Name</b></div>
              <input
                matInput
                autocomplete="off"
                type="text"
                name="jmepName"
                class="width100"
                [(ngModel)]="formData.name"
                #jmepNameInput="ngModel"
                [disabled]="!hasReadWriteRole"
                (ngModelChange)="validateNameChange()"
                [maxlength]="30"
                required
              />
              <div
                class="error"
                *ngIf="jmepNameInput.invalid && (jmepNameInput.dirty || jmepNameInput.touched)"
              >
                <mat-error *ngIf="jmepNameInput?.errors?.required"> Name is required</mat-error>
                <mat-error *ngIf="jmepNameInput.errors?.pattern"
                  >Can only use characters: a-z A-Z 0-9 ~ @ # + $ % - : . _</mat-error
                >
                <mat-error *ngIf="jmepNameInput.errors?.uniqueName">Name already used</mat-error>
              </div>
            </div>
            <div class="name-input-field field-location">
              <div class="label"><b>Location</b></div>
              <input
                matInput
                autocomplete="off"
                type="text"
                class="width100"
                [(ngModel)]="formData.location"
                #nameInput="ngModel"
                [disabled]="!hasReadWriteRole"
                [maxlength]="30"
              />
            </div>
          </div>
          <div class="latitude-fields">
            <div class="latitude-field">
              <div class="label"><b>Latitude</b></div>
              <input
                matInput
                autocomplete="off"
                type="text"
                name="lat"
                #latitudeInput="ngModel"
                [(ngModel)]="formData.lat"
                [pattern]="latitudeIPRegex"
              />
              <div
                class="error"
                *ngIf="latitudeInput.invalid && (latitudeInput.dirty || latitudeInput.touched)"
              >
                <mat-error *ngIf="latitudeInput.errors?.pattern">Invalid Latitude value</mat-error>
              </div>
            </div>
            <div class="longitude-field">
              <div class="label"><b>Longitude</b></div>
              <input
                matInput
                autocomplete="off"
                type="text"
                name="lon"
                #longitudeInput="ngModel"
                [(ngModel)]="formData.lon"
                [pattern]="longitudeIPRegex"
              />
              <div
                class="error"
                *ngIf="longitudeInput.invalid && (longitudeInput.dirty || longitudeInput.touched)"
              >
                <mat-error *ngIf="longitudeInput.errors?.pattern"
                  >Invalid Longitude value</mat-error
                >
              </div>
            </div>
          </div>

          <div class="header-label"><b>Network</b></div>
          <div class="devider"></div>
          <div class="section-container">
            <div class="left-section-data">
              <div class="input-fields">
                <div class="label"><b>Address</b></div>
                <input
                  matInput
                  autocomplete="off"
                  type="text"
                  name="address"
                  class="width100"
                  [(ngModel)]="formData.address"
                  (ngModelChange)="validateIpAddress()"
                  #addressInput="ngModel"
                  [disabled]="!hasReadWriteRole"
                />
                <div
                  class="error"
                  *ngIf="addressInput.invalid && (addressInput.dirty || addressInput.touched)"
                >
                  <mat-error *ngIf="addressInput.errors?.invalid"
                    >Address is not a valid IPv4 or IPv6 address</mat-error
                  >
                </div>
              </div>
              <div class="input-fields">
                <div class="label"><b>Subnet Length</b></div>
                <input
                  matInput
                  autocomplete="off"
                  type="number"
                  name="subnet"
                  [(ngModel)]="formData.subnet"
                  class="width100"
                  #subnetInput="ngModel"
                  (ngModelChange)="validateSubnetChange()"
                  [placeholder]="subnetLengthEntity.placeholder"
                  [disabled]="!hasReadWriteRole || addressIsEmpty"
                />
                <div
                  class="error"
                  *ngIf="subnetInput.invalid && (subnetInput.dirty || subnetInput.touched)"
                >
                  <mat-error *ngIf="subnetInput?.errors?.invalid">
                    {{ subnetLengthEntity.error }}</mat-error
                  >
                </div>
              </div>
              <div class="input-fields">
                <div class="label">
                  <b>VLAN to terminate</b>
                  <i
                    class="icon mdi mdi-help-circle-outline"
                    matTooltip="Traffic matching this VLAN will not pass through the JMEP"
                  >
                  </i>
                </div>
                <input
                  matInput
                  autocomplete="off"
                  type="number"
                  name="vlan"
                  [(ngModel)]="formData.vlan"
                  #vlanInput="ngModel"
                  [disabled]="!hasReadWriteRole"
                  class="width30"
                  min="1"
                  max="4095"
                />
                <span class="sub-label">(optional)</span>
                <div
                  class="error"
                  *ngIf="vlanInput.invalid && (vlanInput.dirty || vlanInput.touched)"
                >
                  <mat-error *ngIf="vlanInput.errors?.min || vlanInput.errors?.max"
                    >Enter value between 1 - 4095</mat-error
                  >
                </div>
              </div>
            </div>
            <div class="right-section-data">
              <div class="input-fields">
                <div class="label"><b>ARP/NDP</b></div>
                <mat-select
                  class="option-list"
                  #selectedARPOptionInput="ngModel"
                  name="arp"
                  (ngModelChange)="onClickSelectedValues($event, 'arp')"
                  [(ngModel)]="formData.selectedARPOption.value"
                  [disabled]="!hasReadWriteRole"
                  required
                >
                  <mat-option *ngFor="let item of ARPOptions" [value]="item.value">
                    {{ item.name }}
                  </mat-option>
                </mat-select>
                <mat-error
                  *ngIf="!addressIsEmpty && formData.selectedARPOption.value === 'disabled'"
                  >Disabling will lose communication with the JMEP
                </mat-error>
              </div>
              <div class="input-fields">
                <div class="label"><b>Gateway IP</b></div>
                <input
                  matInput
                  autocomplete="off"
                  type="text"
                  name="gateway"
                  class="width100"
                  [(ngModel)]="formData.gateway"
                  #gatewayInput="ngModel"
                  (ngModelChange)="validateGatewayChange()"
                  [disabled]="!hasReadWriteRole || addressIsEmpty"
                />
                <div
                  class="error"
                  *ngIf="gatewayInput.invalid && (gatewayInput.dirty || gatewayInput.touched)"
                >
                  <mat-error *ngIf="gatewayInput.errors?.invalid">{{
                    gatewayEntity?.error
                  }}</mat-error>
                </div>
              </div>
              <div class="checkbox-field">
                <mat-checkbox
                  [checked]="formData.enablePingResponse"
                  [disabled]="!hasReadWriteRole"
                  name="ping"
                  [(ngModel)]="formData.enablePingResponse"
                  (click)="onClickSelectedValues($event, 'ping')"
                  color="primary"
                >
                  <div class="label"><b>Enable Ping Response</b></div>
                </mat-checkbox>
              </div>
              <div class="checkbox-field">
                <mat-checkbox
                  [checked]="formData.enableLosPin"
                  [disabled]="!hasReadWriteRole"
                  name="losPin"
                  [(ngModel)]="formData.enableLosPin"
                  (click)="onClickSelectedValues($event, 'losPin')"
                  color="primary"
                >
                  <div class="label"><b>Mask LoS Pin</b></div>
                </mat-checkbox>
              </div>
            </div>
          </div>
          <div class="header-label"><b>Inline loopback</b></div>
          <div class="devider"></div>
          <div class="section-container">
            <div class="left-section-data">
              <div class="input-fields">
                <div class="label">
                  <b>Equipment Interface</b>
                  <i
                    class="icon mdi mdi-help-circle-outline"
                    matTooltip="Source Specific Layer 2 loop requests on JMEP-3 return packets matching VLAN and source MAC; JMEP-10 only uses source MAC."
                  >
                  </i>
                </div>
                <mat-select
                  class="option-list"
                  #equipmentInterfaceInput="ngModel"
                  name="equipment"
                  (ngModelChange)="
                    onClickSelectedValues($event, 'equipmentInterface'); onInterfaceChange()
                  "
                  [(ngModel)]="formData.equipmentInterface.value"
                  [disabled]="!hasReadWriteRole"
                  required
                >
                  <mat-option *ngFor="let item of loopbackInterface" [value]="item.value">
                    {{ item.name }}
                  </mat-option>
                </mat-select>
              </div>
              <div class="checkbox-field" *ngIf="!interfaceDisabled">
                <mat-checkbox
                  [checked]="formData.enableViaviHello"
                  [disabled]="!hasReadWriteRole"
                  name="viavi"
                  [(ngModel)]="formData.enableViaviHello"
                  (click)="onClickSelectedValues($event, 'viavi')"
                  color="primary"
                >
                  <b class="second-label">Respond to VIAVI Hello</b></mat-checkbox
                >
              </div>
            </div>
            <div class="right-section-data">
              <div class="input-fields">
                <div class="label">
                  <b>Network Interface</b>
                  <i
                    class="icon mdi mdi-help-circle-outline"
                    matTooltip="Source Specific Layer 2 loop requests on JMEP-3 return packets matching VLAN and source MAC; JMEP-10 only uses source MAC."
                  >
                  </i>
                </div>
                <mat-select
                  class="option-list"
                  #networkInterfaceInput="ngModel"
                  name="network"
                  (ngModelChange)="
                    onClickSelectedValues($event, 'networkInterface'); onInterfaceChange()
                  "
                  [(ngModel)]="formData.networkInterface.value"
                  [disabled]="!hasReadWriteRole"
                  required
                >
                  <mat-option *ngFor="let item of loopbackInterface" [value]="item.value">
                    {{ item.name }}
                  </mat-option>
                </mat-select>
              </div>
            </div>
          </div>
          <div class="header-label"><b>Other</b></div>
          <div class="devider"></div>
          <div class="section-container">
            <div class="left-section-data">
              <div class="input-fields">
                <div class="label"><b>802.3ah</b></div>
                <mat-select
                  class="option-list"
                  #selectedDyingGaspOptionInput="ngModel"
                  name="dyingGasp"
                  [(ngModel)]="formData.selectedDyingGaspOption.value"
                  (ngModelChange)="onClickSelectedValues($event, 'selectedDyingGaspOption')"
                  [disabled]="!hasReadWriteRole"
                  required
                >
                  <mat-option *ngFor="let item of dyingGaspOptions" [value]="item.value">
                    {{ item.name }}
                  </mat-option>
                </mat-select>
              </div>
            </div>
            <div class="right-section-data">
              <div class="input-fields">
                <div class="label"><b>Timing Mode</b></div>
                <mat-select
                  class="option-list"
                  #selectedModeOptionInput="ngModel"
                  name="mode"
                  [(ngModel)]="formData.selectedModeOption.value"
                  (ngModelChange)="onClickSelectedValues($event, 'selectedModeOption')"
                  [disabled]="!hasReadWriteRole"
                  required
                >
                  <mat-option *ngFor="let item of timingMode" [value]="item.value">
                    {{ item.name }}
                  </mat-option>
                </mat-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div *ngIf="!isLoading">
    <div class="btn-group btn-align">
      <button
        mat-flat-button
        class="save-btn"
        [disabled]="!form.valid || disableAction"
        (click)="saveConfigDetails()"
      >
        APPLY
      </button>
      <button mat-button class="save-btn cancel" mat-dialog-close>CANCEL</button>
    </div>
  </div>
  <div class="loader-content" *ngIf="isLoading">
    <div class="spinner">
      <mat-spinner [diameter]="60"></mat-spinner>
    </div>
    <div class="loader-text">
      <div class="text-message">Loading...</div>
    </div>
  </div>
</div>
